export const Configuration = {
    api: {
      base: process.env.VUE_APP_API + "/api",
      
    }
  };